// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"527":"6787fe92939f2a13938d","572":"28e0eaf25847f105cec6"}[chunkId] + ".css";
};